module.exports = __webpack_public_path__ + "img/mask-group-24@1xcopy.a51dbf8f.png";